// src/hooks/useReservaLogs.ts
import { useQuery } from "@tanstack/react-query";
import api from "../api/axios";

export function useReservaLogs(reservaId?: number) {
  return useQuery({
    queryKey: ["reservaLogs", reservaId],
    enabled: !!reservaId,
    queryFn: () => api.get(`/reservas/${reservaId}/logs`).then((r) => r.data),
  });
}
